import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
  structuredData?: object;
  noindex?: boolean;
  canonical?: string;
  alternateLanguages?: Array<{lang: string, url: string}>;
}

const SEOHead: React.FC<SEOHeadProps> = ({
  title = "HN Engenharia e Construções | Engenharia Civil, Projetos Estruturais e Consultoria Especializada",
  description = "🏗️ HN Engenharia: Líder em engenharia civil, projetos estruturais, consultoria técnica e gerenciamento de obras. Soluções inovadoras com qualidade garantida. Orçamento gratuito!",
  keywords = "engenharia civil, engenheiro civil, projetos estruturais, consultoria engenharia, gerenciamento obras, HN Engenharia, engenharia construção, projetos arquitetônicos, engenharia brasil, consultoria técnica, estruturas, fundações, reformas, laudos técnicos",
  image = "https://hnengenharia.org/logo512.png",
  url = "https://hnengenharia.org",
  type = "website",
  structuredData,
  noindex = false,
  canonical,
  alternateLanguages = []
}) => {
  return (
    <Helmet>
      {/* Título da página */}
      <title>{title}</title>
      
      {/* Meta tags básicas */}
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"} />
      <meta name="googlebot" content={noindex ? "noindex, nofollow" : "index, follow"} />
      <meta name="author" content="HN Engenharia" />
      <meta name="revisit-after" content="7 days" />
      <link rel="canonical" href={canonical || url} />
      
      {/* Alternate languages */}
      {alternateLanguages.map((alt, index) => (
        <link key={index} rel="alternate" hrefLang={alt.lang} href={alt.url} />
      ))}
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="512" />
      <meta property="og:image:height" content="512" />
      <meta property="og:image:alt" content="HN Engenharia - Logo da empresa" />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="HN Engenharia" />
      <meta property="og:locale" content="pt_BR" />
      <meta property="og:locale:alternate" content="en_US" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@hnengenharia" />
      <meta name="twitter:creator" content="@hnengenharia" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content="HN Engenharia - Logo" />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;
